import { Select, MenuItem, FormControl, InputLabel } from '@mui/material';
import { useEffect, useState } from 'react';

const Dropdown = ({
	options = [],
	placeholder = '',
	size = 'lg',
	label = '',
	value = '',
	onSelectChange,
	error,
	disabled,
	variant = 'filled',
	background,
}) => {
	const [selectedValue, setSelectedValue] = useState(value);

	useEffect(() => {
		setSelectedValue(value);
	}, [value]);

	const changeHandler = (e) => {
		if (e && e.target && e.target.value) {
			const selectedOption = options.find((option) => option.id === e.target.value);

			if (selectedOption) {
				onSelectChange({ ...selectedOption });
				setSelectedValue(selectedOption.id);
			}
		}
	};

	return (
		<FormControl fullWidth error={error} variant={variant}>
			<InputLabel id="demo-simple-select-label">{label}</InputLabel>
			<Select
				onChange={changeHandler}
				placeholder={placeholder}
				label={label}
				value={selectedValue}
				disabled={disabled}
				sx={{ background: background }}
			>
				{options.map(({ id, name }) => (
					<MenuItem value={id} key={`option-id-${id}`}>
						{name}
					</MenuItem>
				))}
			</Select>
		</FormControl>
	);
};

export default Dropdown;
